import axios from "axios";

import ENV from "../../../../../../../util/env-config";

class Service {
  static getCommunicationChannels(requestData) {
    return axios.post(ENV.keylockerBase + "/drop/channels", requestData);
  }
}

export default Service;
